<template lang="html">
  <div class="full-page">
    <i-header title="投资者基本信息" @leftClick="$_headerLeftClick">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <cube-form
        class="form-custom"
        :model="Model"
        :options="options"
        @submit="$_handlerSubmit">
        <cube-form-group legend="基本信息">
          <cube-form-item :field="Fields[0]"></cube-form-item>
          <cube-form-item :field="Fields[1]">
            <div @click.stop="$_handleShowOrgTypePicker" style="text-align:right;">
              <span
                :style="{'color': Model.orgType ? '#666' : '#ccc'}">
                {{Model.orgType || '请选择机构类型'}}
              </span>
              <i class="cubeic-arrow" style="color: #666"></i>
            </div>
          </cube-form-item>
          <cube-form-item :field="Fields[2]"></cube-form-item>
          <cube-form-item :field="Fields[3]"></cube-form-item>
          <cube-form-item :field="Fields[4]">
            <div @click.stop="$_handleShowOrgDocumentsValidityPicker" style="text-align:right;">
              <span
                :style="{'color': Model.orgDocumentsValidity ? '#666' : '#ccc'}">
                {{Model.orgDocumentsValidity || '请选择证件有效期'}}
              </span>
              <i class="cubeic-arrow" style="color: #666"></i>
            </div>
          </cube-form-item>
          <cube-form-item :field="Fields[5]"></cube-form-item>
        </cube-form-group>

        <cube-form-group legend="">
          <cube-form-item :field="Fields[6]"></cube-form-item>
          <cube-form-item :field="Fields[7]"></cube-form-item>
          <cube-form-item ref="orgRegisteredCapital" :field="Fields[8]"></cube-form-item>
        </cube-form-group>

        <cube-form-group legend="" >
          <cube-form-item :field="Fields[9]">
            <div @click.stop="$_handleShowOrgBusinessScopePicker" style="text-align:right;">
              <span
                :style="{'color': Model.orgBusinessScope ? '#666' : '#ccc'}">
                {{Model.orgBusinessScope || '请选择机构经营范围'}}
              </span>
              <i class="cubeic-arrow" style="color: #666"></i>
            </div>
          </cube-form-item>
          <cube-form-item :field="Fields[10]"></cube-form-item>
          <cube-form-item :field="Fields[11]"></cube-form-item>
          <cube-form-item :field="Fields[12]"></cube-form-item>
        </cube-form-group>

        <cube-form-group legend="" class="submit-btn">
          <cube-button type="submit">确认</cube-button>
        </cube-form-group>
      </cube-form>
    </i-body>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getInvestorInfoDraftSave } from '@/api/investor';
import mixin from './config/draftBaseConfig';
import cmixin from '../../commonConfig';

export default {
  mixins: [mixin, cmixin],
  computed: {
    ...mapGetters(['managerInfo', 'au']),
  },
  mounted() {
    setTimeout(() => {
      this.$bridge.callHandler('getBaseInfo', { msg: '获取投资者基本信息' }, (data) => {
        const obj = JSON.parse(data);
        console.log('草稿', obj);
        this.$_handlerInit(obj.baseInfo);
      });
    }, 300);
  },
  methods: {
    /**
     * 初始数据
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    $_handlerInit(data) {
      const obj = JSON.parse(data);
      Object.keys(this.Model).forEach((key) => {
        if (obj[key]) {
          this.Model[key] = obj[key];
        }
      });
      if (this.Model.orgDocumentsValidity === '永久有效') {
        this.Model.isOrgValidateForever = true;
      } else {
        this.Model.isOrgValidateForever = false;
      }
    },
    $_handlerSubmit(e) {
      e.preventDefault();
      this.$_handleSaveInfo();
    },
    $_handleSaveInfo() {
      const toast = this.$createToast({
        txt: '加载中...',
        type: 'loading',
        mask: true,
        time: 0,
      }).show();
      getInvestorInfoDraftSave({
        financialUserId: this.managerInfo.userId,
        specificCode: this.managerInfo.invenstemType,
        investorInfo: JSON.stringify(this.Model),
        draftsNo: this.$route.query.draftsNo,
      }, this.au).then((res) => {
        toast.hide();
        if (res.code === 0) {
          this.$bridge.callHandler('getResult', { msg: '修改草稿箱基本信息', json: JSON.stringify(this.Model) }, () => {
          });
        } else {
          this.$createToast({
            type: 'txt',
            txt: res.msg,
            mask: true,
            time: 2000,
          }).show();
        }
      });
    },
  },
};
</script>
